import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface CommunityAndManagementContainerProps {
  userId: string;
  propertyId: string;
}

export const CommunityAndManagementContainer: React.FC<
  CommunityAndManagementContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ pl: 6 }}>
      {/* Strata Management Company Info */}
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Management Company Name"
        fieldKey="communityAndManagement.strataManagementCompanyInfo.name"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Management Company Contact"
        fieldKey="communityAndManagement.strataManagementCompanyInfo.contact"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Management Company Notes"
        fieldKey="communityAndManagement.strataManagementCompanyInfo.notes"
      />

      {/* Council Info */}
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Council Members"
        fieldKey="communityAndManagement.councilInfo.numberOfMembers"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Council Meeting Frequency"
        fieldKey="communityAndManagement.councilInfo.meetingFrequency"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Current Council Initiatives"
        fieldKey="communityAndManagement.councilInfo.currentInitiatives"
      />
    </Box>
  );
};
